import Container from '@mui/material/Container';
import Box from '@mui/system/Box';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import ListAltIcon from '@mui/icons-material/ListAlt';
import '../CSS/Estilo.css';

export default function MenuGestionUsuarios({estiloPagina,onClick})
{
    const estiloIcono={
        fontSize:'1.2em',
        ml:'15px'
      }

    return(    
        <Box>
            <Container sx={{display:'flex'}}>
                <label style={{color:estiloPagina.color}} className='rotuloMediano'>Menú</label>
            </Container>                    
            <Box  id="DivButtons" onClick={onClick}>
                <button id={"btNou"} className="btMenu">
                    <Box id='box' sx={{display:'inline-flex',alignContent:'center'}}>
                        Añadir usuario
                        <GroupAddIcon sx={estiloIcono}></GroupAddIcon>
                    </Box>
                </button>
                <button id={"btEdit"} className="btMenu">
                    <Box id='box' sx={{display:'inline-flex',alignContent:'center'}}>
                        Editar usuario
                            <ModeEditOutlineIcon sx={estiloIcono}></ModeEditOutlineIcon>
                    </Box>
                </button>
                <button id={"btBorra"} className="btMenu">
                    <Box id='box' sx={{display:'inline-flex',alignContent:'center'}}>
                        Borrar usuario
                        <PersonRemoveIcon sx={estiloIcono}></PersonRemoveIcon>
                    </Box>                        
                </button>
                <button id={"btList"} className="btMenu">
                    <Box id='box' sx={{display:'inline-flex',alignContent:'center'}}>
                        Listar usuarios
                        <ListAltIcon sx={estiloIcono}></ListAltIcon>
                    </Box>
                </button>
            </Box>  
        </Box>
    )
}